import { render, staticRenderFns } from "./MyHonour.vue?vue&type=template&id=2a1bb5c2&"
import script from "./MyHonour.vue?vue&type=script&lang=js&"
export * from "./MyHonour.vue?vue&type=script&lang=js&"
import style0 from "./MyHonour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports